// 1 thing | multiple things.
// 0 things | 1 thing | multiple things.
// 0 things | 1 thing | few things | multiple things.

export default function ruPluralization(choice: number, choicesLength: number): number {
  if (choicesLength === 2) {
    if (choice === 0 || choice > 1) {
      return 1;
    }
    return 0;
  }

  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return (choicesLength < 4) ? 2 : 3;
}
